import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import Popover from 'Views/Components/_HumanWritten/Popover';

/**
 * Why a capacity says `(closed)`.
 *
 * <p>The word on its own reads as the ferry being full, which is a different thing and has a
 * different answer — a full sailing has a waitlist, a closed one has a phone number. So the chip
 * carries a mark that says what closed actually means for this booker: the sailing is still
 * running, they just cannot take it from here.</p>
 *
 * <p><b>Hover on a desktop, tap on a phone</b>, which is what `openOnHover` gives: the pointer
 * opens it where there is a pointer, and the button opens it everywhere.</p>
 *
 * <p>`floating`, and not the app's CSS tooltip, because of where this sits. The chip is inside the
 * fare table, the chosen card's shell and — on a phone — the sailing card, each of which sets
 * `overflow: hidden` to keep its corners rounded. An absolutely-positioned panel inside any of them
 * is cut off at that element's edge; a portalled one is not.</p>
 */
export default function ClosedCapacityInfo() {
	return (
		<Popover
			floating
			openOnHover
			// The card behind this is itself a button — see `stopPropagation`.
			stopPropagation
			containerClassName="capacity-closed"
			buttonClassName="capacity-closed__trigger"
			popoverClassName="capacity-closed__panel"
			buttonTestId="capacity-closed-info"
			buttonContent={
				// `Icon` takes no accessible name of its own, so the name sits on a wrapper — a
				// screen reader otherwise announces an unlabelled button.
				<span aria-label="Why this is closed" role="img">
					<Icon name="info" useMaterialIcons />
				</span>
			}
			popoverContent={() => (
				<FormattedMessage
					id="capacity-closed__info__message"
					defaultMessage="Online bookings are no longer available for this trip. Please contact staff to book."
				/>
			)}
		/>
	);
}
